// External Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Internal Dependencies
import SingleAttendee from './SingleAttendee';

// Local Variables
const propTypes = {
  coders: PropTypes.arrayOf(PropTypes.object),
  onToggle: PropTypes.func.isRequired,
};

const defaultProps = {
  coders: [],
};

const rootStyles = {
  marginBottom: 18,
  marginTop: 18,
};

// Component Definition
const AttendanceList = (props) => {
  const {
    coders,
    onToggle,
  } = props;

  const renderCoders = () =>
    coders.map(coder => (
      <SingleAttendee
        {...coder}
        key={coder.id}
        onToggle={onToggle}
      />
    ));

  return (
    <div style={rootStyles}>
      {renderCoders()}
    </div>
  );
};

AttendanceList.propTypes = propTypes;
AttendanceList.defaultProps = defaultProps;
export default AttendanceList;



/** WEBPACK FOOTER **
 ** ./src/dashboard/update-attendance/attendance-list.js
 **/